import * as MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';

import { SignInComponent } from '../../gh-signin-button/components/SignInComponent';

export interface IGuestAddToWishlistProps {
    className?: string;
    buttonText: string;
    signInDrawerTitle: string;
    moduleProps: MsDyn365.IModule;
}

/**
 * Add-to-wishlist button shown to anonymous users.
 * Mirrors the SDK component's markup so the buybox styling applies unchanged,
 * but opens the sign-in drawer instead of navigating to the B2C policy.
 */
export const GuestAddToWishlist: React.FC<IGuestAddToWishlistProps> = ({ className, buttonText, signInDrawerTitle, moduleProps }) => (
    <SignInComponent
        drawerTitle={signInDrawerTitle}
        moduleProps={moduleProps}
        renderTrigger={open => (
            <button className={classnames('msc-add-to-wishlist', className)} aria-label={buttonText} role='button' onClick={open} />
        )}
    />
);
